export default {
  trendingTopics: [],
  getTrendingTopicsSuccess: false,
  getTrendingTopicsError: null,
  offset: false,
  colors: ["#e74e29", "#7d61e1", "#3faff3", "#a8947b"],
};



// WEBPACK FOOTER //
// ./src/reducers/initialState/trending.js